(function() {
    const productFormWrapper = document.querySelector('.product-form-wrapper form');
    if (!productFormWrapper) return;

    let hulkAppsMoved = false;
    let observer = null;

    const syncPrescriptionSelect = (hulkAppsOptions) => {
        // Novo formato Hulk: radios em .hulkapps_option_value (value = Non-Prescription | Prescription | Readers)
        const optionValueContainer = hulkAppsOptions.querySelector('.hulkapps_option_value');
        if (optionValueContainer) {
            const prescriptionRadios = optionValueContainer.querySelectorAll('input[type="radio"][data-conditional-value]');
            if (prescriptionRadios.length) {
                prescriptionRadios.forEach((radio) => {
                    radio.addEventListener('change', (event) => {
                        const value = event.target.value || event.target.getAttribute('data-conditional-value');
                        if (!value) return;
                        const prescriptionInputs = Array.from(document.querySelectorAll('[name="Prescription"]'));
                        const prescriptionInput = prescriptionInputs.find((input) => input.getAttribute('data-option-value') === value);
                        if (prescriptionInput) {
                            const label = prescriptionInput.parentElement?.querySelector('label');
                            if (label) label.click();
                        }
                    });
                });
                return;
            }
        }
        // Fallback: formato antigo com select
        const hulkProductOptionsSelect = hulkAppsOptions.querySelector('.hulkapps_product_options select');
        if (hulkProductOptionsSelect) {
            hulkProductOptionsSelect.addEventListener('change', (event) => {
                const value = event.target.value;
                const prescriptionInputs = Array.from(document.querySelectorAll('[name="Prescription"]'));
                const prescriptionInput = prescriptionInputs.find((input) => input.getAttribute('data-option-value') == value);
                if (prescriptionInput) {
                    const label = prescriptionInput.parentElement?.querySelector('label');
                    if (label) label.click();
                }
            });
        }
    };

    const moveHulkAppsOptions = () => {
        if (hulkAppsMoved) return;
        
        const hulkAppsOptions = document.querySelector('[id^="hulkapps_custom_options_"]');
        if (hulkAppsOptions && !hulkAppsOptions.dataset.moved) {
            hulkAppsOptions.dataset.moved = 'true';
            hulkAppsMoved = true;
            
            productFormWrapper.insertBefore(hulkAppsOptions, productFormWrapper.firstChild);
            
            syncPrescriptionSelect(hulkAppsOptions);
            
            if (observer) {
                observer.disconnect();
            }
        }
    };

    moveHulkAppsOptions();

    if (!hulkAppsMoved) {
        observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        if (node.id && node.id.startsWith('hulkapps_custom_options_')) {
                            moveHulkAppsOptions();
                            return;
                        }
                        if (node.querySelector && node.querySelector('[id^="hulkapps_custom_options_"]')) {
                            moveHulkAppsOptions();
                            return;
                        }
                    }
                }
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }
})();

// window._klOnsite = window._klOnsite || [];
// window._klOnsite.push(['openForm', 'UyXx5e']);

// window._klOnsite = window._klOnsite || [];
// window._klOnsite.push(['openForm', 'WS8RLi']);
